<template>
    <div class="modal general-card-modal" :class="{'is-active': isModalOpen = isActive}">
      <div class="modal-background"></div>
      <div class="modal-content b-card">
        <div class="card no-margin">
          <div class="card-title">
            <span>Edit User</span>
          </div>
          <div class="columns is-mobile card-form">
            <div class="column">
              <div class="field">
                <div class="label">
                  Role
                  <sup>*</sup>
                </div>
                <div class="control is-expanded">
                  <select
                    class="select is-fullwidth"
                    v-model="userModal.userData.role"
                    disabled
                  >
                    <option value="user">Bot Trainer</option>
                    <option value="admin">Bot Admin</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns is-mobile card-form">
            <div class="column">
              <div class="field">
                <div class="label">
                  Email
                  <sup>*</sup>
                </div>
                <div class="control is-expanded">
                  <input
                    class="input"
                    type="email"
                    placeholder="Enter email"
                    v-model="userModal.userData.email"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="columns is-mobile card-form">
            <div class="column">
              <div class="field">
                <div class="label">
                  Username
                  <sup>*</sup>
                </div>
                <div class="control is-expanded">
                  <input
                    class="input"
                    type="text"
                    placeholder="Enter username"
                    v-model.trim="userModal.userData.username"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="columns is-mobile card-form">
            <div class="column">
              <div class="field">
                <div class="label">
                  Password
                  <sup>*</sup>
                </div>
                <div class="control is-expanded">
                  <input
                    class="input"
                    type="password"
                    placeholder="Leave blank if you do not want to change it."
                    v-model="userModal.userData.password"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="card-action">
            <button class="button is-primary" @click.prevent="saveEditData">
              <span>Save</span>
            </button>
            <button class="button is-white" @click="closeModal">Cancel</button>
          </div>
        </div>
        <button class="modal-close is-large" aria-label="close"
                @click="closeModal"></button>
      </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'change-password-modal',
  props: {
    isActive: Boolean,
    userInfoData: Object,
  },
  data() {
    return {
      isModalOpen: false,
      userModal: {
        userId: '',
        userData: {
          username: '',
          password: '',
          email: '',
          role: '',
        },
      },
    };
  },
  watch: {
    isModalOpen() {
      this.setUserModal();
    },
  },
  mounted() {
    this.reloadUserInfo();
  },
  computed: {
    ...mapGetters({
      userInfo: 'config/userInfo',
    }),
  },
  methods: {
    ...mapActions({
      loadUserInfo: 'config/loadUserInfo',
      updateUser: 'usermanager/updateUser',
    }),
    setUserModal() {
      this.userModal.userId = this.userInfoData.id;
      this.userModal.userData = {
        username: this.userInfoData.username,
        password: '',
        email: this.userInfoData.email,
        role: this.userInfoData.role,
      };
    },
    async reloadUserInfo() {
      await this.loadUserInfo();
    },
    async saveEditData() {
      const { userData } = this.userModal;
      const { userId } = this.userModal;
      try {
        await this.updateUser({ userId, userData });
        this.$buefy.toast.open({
          type: 'is-success',
          message: 'User info updated.',
          position: 'is-bottom',
        });
        this.reloadUserInfo();
      } catch (e) {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'Update user failed.',
          position: 'is-bottom',
        });
      } finally {
        this.closeModal();
      }
    },
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  z-index: 1100 !important;
    .modal-content {
      width: 640px;
  }
}
</style>
